// Column C of Find RICs: the correspondence text written next to a RIC, and
// the reader of its "k sur N" marker (which the switch-candidate feature reads
// back from the sheet).
//
// Layout: <name> · <type>[ · <status>][ · k sur N][ · résultat partiel], the
// parts joined by " · " (space, U+00B7, space). The French strings are fixed.

import type { Resolution } from "./resolve";

const SEP = " · ";

export const NO_RESULT = "Aucun résultat";
export const UNAVAILABLE = "Recherche indisponible";
export const PARTIAL = "résultat partiel";

export function formatC(r: Resolution): string {
  if (r.status === "none") return NO_RESULT;
  if (r.status === "unavailable") return r.reason ? `${UNAVAILABLE} : ${r.reason}` : UNAVAILABLE;

  const parts: string[] = [];
  if (r.name) parts.push(r.name);
  if (r.type) parts.push(r.type);
  if (r.itemStatus) parts.push(r.itemStatus);
  if (r.k !== undefined && r.n !== undefined) parts.push(`${r.k} sur ${r.n}`);
  if (r.partial) parts.push(PARTIAL);
  return parts.join(SEP);
}

const MARKER = /^(\d+) sur (\d+)$/;

/**
 * Reads the « k sur N » part of a column C text. It must be a whole part (set
 * off by " · "), so a name that happens to contain "sur" is not a marker.
 */
export function parseMarker(c: string): { k: number; n: number } | null {
  const parts = c.split(SEP);
  for (let i = parts.length - 1; i >= 0; i--) {
    const m = MARKER.exec(parts[i]);
    if (m) return { k: Number(m[1]), n: Number(m[2]) };
  }
  return null;
}
